import { colorsPalettes } from "@similarweb/styles";
import { Box, Flex } from "@similarweb/ui-components/foundations";

import { isAvailable } from "app/common/services/pageClaims";
import { swSettings } from "app/common/services/swSettings";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { type LinkCTAProps, LinkCTA } from "./components/LinkCTA";
import { type ILockedWithHookCTAProps, LockedWithHookCTA } from "./components/LockedWithHookCTA";
import { allTrackers } from "app/services/track/track";

const { carbon } = colorsPalettes;

const WidgetFooterDivider = () => (
    <Box
        position="absolute"
        left={0}
        right={0}
        bottom="52px"
        borderBottom={`1px solid ${carbon[50]}`}
    />
);

interface IFooterComponentProps
    extends Pick<LinkCTAProps, "href" | "target" | "onClick">, Partial<Pick<ILockedWithHookCTAProps, "unlockHook">> {
    text: string;
}

export const FooterComponent = ({ href, onClick, text, unlockHook, target = "_self" }: IFooterComponentProps) => {
    const translate = useTranslation();
    const label = translate(text);

    if (unlockHook && !isAvailable(swSettings.components[unlockHook.component])) {
        return (
            <LockedWithHookCTA
                label={label}
                unlockHook={unlockHook}
            />
        );
    }
    return (
        <LinkCTA
            href={href}
            target={target}
            label={label}
            onClick={onClick}
        />
    );
};

interface IWidgetFooterProps extends Omit<IFooterComponentProps, "trackButtonClicked"> {
    trackingLabel: string;
}

export const WidgetFooter = ({ trackingLabel, ...props }: IWidgetFooterProps) => {
    const handleClick = () => {
        allTrackers.dispatchTrackEvent("Internal Link", "click", `${trackingLabel || ""}`);
    };

    return (
        <>
            <Flex>
                <Box
                    position="absolute"
                    width="auto"
                    right="16px"
                    bottom="8px"
                >
                    <FooterComponent
                        onClick={handleClick}
                        {...props}
                    />
                </Box>
            </Flex>
            <WidgetFooterDivider />
        </>
    );
};
